/**
 * @description: 判断值是否未某个类型
 */
export function is(val, type) {
  return toString.call(val) === `[object ${type}]`
}


/**
 * @description: 是否为对象
 */
export const isObject = (val) => {
  return val !== null && is(val, 'Object')
}



/**
 *  @description: 是否为空对象
 */
export const isUnEmptyObject = (val) => {
  if (!isObject(val)) return false
  // return val !== null && is(val, 'Object')
  const arr = Object.keys(val)
  return arr.length !== 0
}